import { sortOrder } from './sortOrder';
import { resolveSorter } from './resolveSorter';
import { resolveSortIcon } from './resolveSortIcon';
/**
 * Builds a sortable column from the sort details
 * @param sortableDetails
 * @param column
 * @param data
 * @param theme
 * @param headerBackgroundColor
 */
export const buildSortFromDetails = (sortableDetails, column, data, theme, headerBackgroundColor) => {
  return {
    ...column,
    sorter: resolveSorter(sortableDetails, column, data),
    ...sortOrder(sortableDetails.activeSortColumn, sortableDetails.defaultSortOrder, sortableDetails.sortOrder, column.dataIndex),
    sortIcon: resolveSortIcon(theme, headerBackgroundColor)
  };
};